import React, { Component } from "react";

export class Info extends Component {
  render() {
    return (
      <div>
        <h1>Info Page</h1>
      </div>
    );
  }
}

export default Info;
